import { render, staticRenderFns } from "./ButtonFindPoint.vue?vue&type=template&id=1518b3d6&scoped=true&"
import script from "./ButtonFindPoint.vue?vue&type=script&lang=js&"
export * from "./ButtonFindPoint.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFindPoint.vue?vue&type=style&index=0&id=1518b3d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1518b3d6",
  null
  
)

export default component.exports